import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70df9879"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-label": "Page navigation example" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  "aria-label": "Previous"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left text-color" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "page-link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  "aria-label": "Next"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right text-color" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import { ref, watch, watchEffect } from 'vue'
import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import { ROOT_STORE } from '@/store/constants'

export default /*#__PURE__*/_defineComponent({
  props: {
  totalPage: {
    type: Number,
    default: 0,
  },
  pageOfNumber: {
    type: Number,
    default: 30,
  },

  curPage: {
    type: Number,
    default: 1,
  },
},
  emits: ['changeQuery'],
  setup(__props, { emit }) {

const props = __props

const visiblePages = ref()
const currentPage = ref(1)

const store = useStore()
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const handleSelectPage = (curPage) => {
  if (curPage === currentPage.value) {
    return
  }
  currentPage.value = curPage
  let query = { page: curPage, page_of_number: props.pageOfNumber }
  emit('changeQuery', query)
}



const handleNextBackPage = (type) => {
  if ((Number(currentPage.value) >= props.totalPage && type === 'add') || (Number(currentPage.value) <= 1 && type === 'sub')) {
    return
  }

  if (type === 'add') {
    currentPage.value = Number(currentPage.value) + 1
  } else {
    currentPage.value = Number(currentPage.value) - 1
  }
  let query = { page: currentPage.value, page_of_number: props.pageOfNumber }
  emit('changeQuery', query)
}

watchEffect(() => {
  if (props.curPage) {
    currentPage.value = Number(props.curPage)
    return
  }
})

watchEffect(() => {
  if (props.curPage) {
    currentPage.value = Number(props.curPage)
    return
  }
})

watchEffect(() => {
  if (Number(currentPage.value) <= 7 && Number(props.totalPage) <= 7) {
    visiblePages.value = Array.from({ length: props.totalPage }, (_, i) => i + 1)
    return
  }
  if (Number(currentPage.value) < 5 && Number(props.totalPage) > 7) {
    if (!isMobile.value) {
      visiblePages.value = [...Array.from({ length: 5 }, (_, i) => i + 1), '...', props.totalPage - 1, props.totalPage]
      return
    } else {
      visiblePages.value = [...Array.from({ length: 1 }, (_, i) => i + 1), '...', props.totalPage]
    }
  }
  if (Number(currentPage.value) >= 5 && Number(props.totalPage) > 7) {
    if (Number(props.totalPage) - Number(currentPage.value) >= 4) {
      if (!isMobile.value) {
        visiblePages.value = [
          1,
          2,
          '...',
          ...Array.from({ length: 3 }, (_, i) => {
            let a = i + Number(currentPage.value) - 2
            return a + 1
          }),
          '...',
          props.totalPage - 1,
          props.totalPage,
        ]
        return
      } else {
        visiblePages.value = [
          ...Array.from({ length: 1 }, (_, i) => {
            let a = i + Number(currentPage.value) - 2
            return a + 1
          }),
          '...',
          props.totalPage,
        ]
      }
    }
    if (Number(props.totalPage) - Number(currentPage.value) < 4) {
      if (!isMobile.value) {
        visiblePages.value = [
          1,
          2,
          '...',
          ...Array.from({ length: 4 }, (_, i) => {
            let a = i + Number(props.totalPage) - 5
            return a + 1
          }),
          Number(props.totalPage),
        ]
        return
      } else {
        visiblePages.value = [
          '...',
          ...Array.from({ length: 1 }, (_, i) => {
            let a = i + Number(props.totalPage) - 2
            return a + 1
          }),
          Number(props.totalPage),
        ]
        return
      }
    }
  }
})

watch(
  () => props.totalPage,
  () => {
    currentPage.value = 1
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", {
      class: _normalizeClass(['pagination', __props.totalPage <= 1 ? 'prevent-click' : 'cursor-pointer'])
    }, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabledButton: Number(currentPage.value) <= 1 || __props.totalPage <= 1 }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleNextBackPage('sub')), ["prevent"]))
      }, _hoisted_3, 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(['page-item ', currentPage.value == page ? 'pageActive' : '', page === '...' ? 'disabledButton' : '']),
          key: index,
          onClick: ($event: any) => (handleSelectPage(page))
        }, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(page), 1)
        ], 10, _hoisted_4))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabledButton: Number(currentPage.value) >= Number(__props.totalPage) || __props.totalPage <= 1 }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleNextBackPage('add')), ["prevent"]))
      }, _hoisted_7, 2)
    ], 2)
  ]))
}
}

})